import { FC } from 'react';
import { Segment } from '~src/interfaces/segment.interface';

import KeyResultsListWrapper from '~src/modules/okrs/manageObjectives/shared/keyResults/KeyResultsListWrapper';

import CreateKeyResultListElement from './CreateKeyResultListElement';

export interface KeyResultAdd {
  id: string;
  name: string;
  startValue: string;
  targetValue: string;
  owners: Segment[];
  weighting: number | null;
}

interface Props {
  deleteKeyResult: (id: string) => void;
  selectKeyResult: (keyResult: KeyResultAdd) => void;
  keyResults: Record<string, KeyResultAdd>;
  showAddModal: () => void;
  onSort?: (sort: string) => void;
}

const CreateKeyResults: FC<Props> = (props) => {
  return (
    <KeyResultsListWrapper
      trigger={props.showAddModal}
      hasContent={Object.values(props.keyResults).length > 0}
    >
      {Object.values(props.keyResults).map((keyResult) => (
        <CreateKeyResultListElement
          key={keyResult.id}
          deleteKeyResult={props.deleteKeyResult}
          selectKeyResult={props.selectKeyResult}
          keyResult={keyResult}
        />
      ))}
    </KeyResultsListWrapper>
  );
};

export default CreateKeyResults;
